import { render, staticRenderFns } from "./config025-f-dimming2.vue?vue&type=template&id=51406138&"
import script from "./config025-f-dimming2.vue?vue&type=script&lang=js&"
export * from "./config025-f-dimming2.vue?vue&type=script&lang=js&"
import style0 from "./config025-f-dimming2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports